"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_session_store_1 = require("owa-session-store");
var owa_options_message_options_1 = require("owa-options-message-options");
exports.default = legacy_1.select({
    editorViewState: function () { return store_1.default.editorViewState; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('initializeSignatureContent')(function initializeSignatureContent(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var editorViewState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    editorViewState = state.editorViewState, userOptions = state.userOptions;
                    return [4 /*yield*/, owa_options_message_options_1.lazyLoadSignatureInUserOptions.importAndExecute()];
                case 1:
                    _a.sent();
                    editorViewState.content = userOptions.SignatureHtml;
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=initializeSignatureContent.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-signature-option/lib/actions/initializeSignatureContent.js
// module id = 3734
// module chunks = 2